import { createBrowserRouter } from "react-router-dom";
import { Routes as RoutesEnum } from "@/types/routes";
import StartPage from "@/pages/start-page";
import MainPage from "@/pages/main-page";
import CheckoutPage from "@/pages/checkout-page";
import VerificationPage from "@/pages/verification-page";
import SuccessPage from "@/pages/success-page";
import PickupTimeSlotPage from "@/pages/pickup-time-slot-page";
import YourInfoPage from "@/pages/your-info-page";

const router = createBrowserRouter([
  { path: RoutesEnum.START, element: <StartPage /> },
  { path: RoutesEnum.MAIN, element: <MainPage /> },
  { path: RoutesEnum.CHECKOUT, element: <CheckoutPage /> },
  { path: RoutesEnum.AGE_VERIFICATION_PAGE, element: <VerificationPage /> },
  { path: RoutesEnum.SUCCESS, element: <SuccessPage /> },

  // pickup module
  { path: RoutesEnum.PICK_UP_TIME_SLOT, element: <PickupTimeSlotPage /> },
  { path: RoutesEnum.YOUR_INFO, element: <YourInfoPage /> },
]);

export default router;
